(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["ewc-slick-slider"] && !window.DesignMode) return;
  try {
    

$(document).ready(function () {
    $('.ewc-slick-slide .ewc-slide-container').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        dots: true,
        arrows: false
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ewc_double_promo"] && !window.DesignMode) return;
  try {
    
  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
      }

      if (/android/i.test(userAgent)) {
          return "Android";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
      }

      return "unknown";
  }
  
  document.querySelector('.app-link').addEventListener('click', function(){
    let os = getMobileOperatingSystem();
    let appLink = document.querySelector('.app-link');
    let appUrl;

    if (os == "Android") {
        appUrl = "https://play.google.com/store/apps/details?id=ewc.ewcandroid"; 
    } else if (os == "iOS") {
        appUrl = "https://apps.apple.com/us/app/ewc/id955013601#?platform=iphone";
    } else if (os == "Windows Phone") {
        appUrl = "https://play.google.com/store/apps/details?id=ewc.ewcandroid";
    } else {
        appUrl = "https://apps.apple.com/us/app/ewc/id955013601#?platform=iphone";
    }

    window.location = appUrl;

  });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ewc_header"]) return;
  try {
    

    if (window.localStorage.getItem('center_location') !== null){
        var savedCenter = JSON.parse(window.localStorage.getItem('center_location')).name;
    } else {
        var savedCenter = "Find your nearest center";
    }

    var centerText = document.querySelectorAll('.center-location');
    for (var i = 0; i < centerText.length; i++) {
        centerText[i].innerHTML = savedCenter;
	}

    // ------------------------------------------------------------------------
    var nav = document.querySelector('.ewc-header .mobile-menu');
    var hamburger = document.querySelector('.hamburger-menu');
    var hamburgerContainer = document.querySelector('.menu-wrapper');
    var mobileLinks = document.querySelectorAll('.ewc-header .mobile-menu li.has-children > a');
    var closeSubmenu = document.querySelectorAll('.ewc-header .mobile-menu .submenu > li.close-submenu');

    hamburgerContainer.addEventListener('click', () => {
        hamburger.classList.toggle('animate');
        nav.classList.toggle('open');
    })

    var handleCloseSubmenu = function(e){
        e.preventDefault();
        var submenu = e.target.offsetParent;
        submenu.classList.toggle('open');
    }

    for (var ii = 0; ii < closeSubmenu.length; ii++) { 
        closeSubmenu[ii].addEventListener('click', handleCloseSubmenu, false);
    }
    
    var handleClick = function(e){
        e.preventDefault();
        var submenu = this.nextSibling;
        submenu.classList.toggle('open');
    }

    for (var i = 0; i < mobileLinks.length; i++) {
        mobileLinks[i].addEventListener('click', handleClick, false);
    }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ewc_services"] && !window.DesignMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {

  (function(){

    var serviceSlider = {
      activeSlide: document.querySelector('.nav > li.active'),
      navItems: document.querySelectorAll('.nav > li'),

      init: function(){
        this.navItems.forEach(function (navItem) {
            navItem.addEventListener('click', function(e){
              var el = e.target;
              //remove active nav item
              document.querySelector('.nav > li.active').classList.toggle('active');


			  //set aria-selected
              document.querySelectorAll('.nav > li').forEach((n,i) => {
            	 $(n).attr('aria-selected', false);
              });

              //make clicked nav item active
              el.classList.toggle('active');
			  $(navItem).attr('aria-selected', true);

              //hide active slide
              document.querySelector('.service-slider .service.active').classList.toggle('active');

              //show clicked slide
              var slideToShow = el.getAttribute("data-slide");
              var slideClass = ".slide-" + slideToShow;
              document.querySelector(slideClass).classList.toggle('active');
            })
        })
      }
    }

    serviceSlider.init();

  })();

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ewc_two_column_slider"] && !window.DesignMode) return;
  try {
    
    $('.img-slider').slick({
        dots: true,
        arrows: false,
        fade: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !window.DesignMode) return;
  try {
    
/*
  $(document).ready(function(){
    $(".testimonial-cards").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "60px",
        variableWidth: true,
        prevArrow: $(".arrow-left"),
        nextArrow: $(".arrow-right"),
        autoplay: true,
        autoplaySpeed: 9500
    });
  });
  */

  } catch(e) { console.error(e); }
})();

})();
